<template>
  <section class="contact">
    <div class="page-container">
      <div class="title-container" id="contact">
        <img class="title-icon" src="@/assets/navbar/contact_icon.png" alt="Icon">
        <h1 class="title">{{ $t('contact.contact') }}</h1>
      </div>
    </div>

    <div v-if=!emailSent>
      <form @submit.prevent="sendEmail">
        <div class="form">
          <div class="form-background">
            <div class="name-email-container">
              <input class="text" type="text" id="name" name="name" :placeholder="$t('contact.name')" v-model="name">
              <input class="text" type="text" id="email" name="email" :placeholder="$t('contact.email')"
                v-model="email">
            </div>

            <div class="subject-container">
              <div class="subject">
                <input class="text" type="text" id="subject" name="subject" :placeholder="$t('contact.subject')"
                  v-model="subject">
              </div>
            </div>

            <div class="message-container">
              <textarea class="text" type="text" id="message" name="message" :placeholder="$t('contact.message')"
                v-model="message"></textarea>
            </div>

            <div class="submit-container">
              <input class="submit" type="submit" value=" ">
              <div class="send-email">
                <img src="@/assets/contact/email.png" alt="Download" class="download-icon">
                <span class="submit-text">{{ $t('contact.send-email') }}</span>
              </div>
            </div>
            <div v-if="showCaptcha" class="captcha">
            
          </div>
          </div>
        </div>
      </form>
    </div>

    <div v-if=emailSent>
      <div class="border-thanks-holder">
        <div class="border-thanks">
          <p class="thanks-text">{{ $t('contact.email-sent') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

import { ref, computed } from 'vue'
import emailjs from 'emailjs-com'
import { useReCaptcha } from 'vue-recaptcha-v3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const name = ref('')
const subject = ref('')
const email = ref('')
const message = ref('')
const emailSent = ref(false)
const sending = ref(false)

const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

const showCaptcha = computed(() => {
  return name.value && email.value && subject.value && message.value
})

const resetForm = () => {
  name.value = ''
  subject.value = ''
  email.value = ''
  message.value = ''
}

const sendEmail = async (e) => {

  // evitar spam click
  if (sending.value) return

  // validação simples
  if (!name.value || !subject.value || !email.value || !message.value) {
    alert(t('contact.fill-all-fields'))

    return
  }

  try {

    sending.value = true

    if (!executeRecaptcha) {
      alert(t('contact.captcha-not-loaded'))

      return
    }

    await recaptchaLoaded()

    // delay humano (anti bot)
    await new Promise(r => setTimeout(r, 100))

    const token = await executeRecaptcha('contact_form')

    if (!token) {
          alert(t('contact.invalid'))

      return
    }

    await emailjs.sendForm(
      'gmail_service',
      'gmail_template',
      e.target,
      'ZaZa9cha-AK-qdFKD',
      {
        name: name.value,
        subject: subject.value,
        email: email.value,
        message: message.value,
        'g-recaptcha-response': token
      }
    )

    // sucesso
    emailSent.value = true
    resetForm()

    // voltar formulário depois de alguns segundos
    setTimeout(() => {
      emailSent.value = false
    }, 4000)

  } catch (error) {

    console.log(error)
    alert(t('contact.invalid'))

  } finally {

    sending.value = false

  }
}

</script>


<style scoped>

.thanks-text {
  font-family: 'Poppins-Regular';
  color: C6C6C5;
  font-size: 15px;
}

.border-thanks-holder {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  transition: opacity .5s
}

.border-thanks {
  border: 4px solid #B1B1B1;
  width: 280px;
  background-color: white;
  border-radius: 25px;
  margin-bottom: 50px;
  align-content: center;
  display: flex;
  justify-content: center;
}

.send-email {
  display: flex;
  pointer-events: none;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 10px;
}

.download-icon {
  align-self: center;
}

.contact {
  background-color: #212121;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: -10px;
  padding-bottom: 20px;
  margin-top: -40px;
}


.message-container {
  display: flex;
  justify-content: center;
  margin-left: 15%;
  margin-right: 15%;
  height: 360px;
}

.name-email-container {
  display: flex;
  margin-top: 25px;
  margin-left: 5%;
  margin-right: 5%;
}

.subject-container {
  margin-left: 5%;
  margin-right: 5%;
}

.submit-container {
  display: flex;
  justify-content: center;
  margin-top: 25px;
  margin-bottom: 25px;
  align-items: center;
  position: relative;
}

.subject {
  display: flex;
}

.text {
  font-family: 'Poppins-Light';
  color: C6C6C5;
  font-size: 15px;
}

.submit-text {
  font-family: 'Poppins-Bold';
  color: white;
  font-size: 25px;
  text-align: justify;
  white-space: normal;
}

textarea {
  resize: none;
  width: 100%;
  margin-left: 5%;
  margin-right: 5%;
  border: 1px solid #C6C6C5;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 15px;
}

input[type=text],
select {
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  padding-right: 12px;
  margin: 15px;
  display: inline-block;
  border: 1px solid #C6C6C5;
  border-radius: 15px;
  box-sizing: border-box;
}

.submit {
  display: flex;
  padding: 0px;
  background-color: #4787FC;
  /* Cor de fundo do botão */
  color: white;
  /* Cor do texto do botão */
  text-decoration: none;
  border-radius: 20px;
  transition: background-color 0.3s ease;
  width: 240px;
  height: 60px;
  justify-content: center;
  position: relative;
  text-align: center;
  border: 2px solid white;
}

input[value=""]::before {
  content: 'fazer a consulta';
  color: #888;
}

input[type=submit]:hover {
  background-color: #2e76fc;
  /* Cor de fundo alterada ao passar o mouse */
}

.form {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.form-background {
  border: 4px solid #B1B1B1;
  width: 70%;
  background-color: white;
  border-radius: 25px;
  margin-bottom: 50px;
}

.page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #111111;
  margin-top: -50px;
}

.title-container {
  display: flex;
  align-items: center;
}

.title-icon {
}

.title {
  font-family: 'Poppins-Regular';
  color: white;
  font-size: 32px;
  margin-left: 10px;
  /* Ajuste conforme necessário */
  text-transform: uppercase;
}

@media(max-width: 1200px) {
  .form-background {
    width: 65%;
  }
}
</style>
